/**
 * Shared region accent colours — used by the Regions homepage cards, the
 * HowItWorks step icons, and the results-page secondary buttons.
 * Keep this the single source of truth; don't re-hardcode these hexes.
 *
 * Two of these intentionally coincide with CSS vars in globals.css:
 * `namibia` = `--bsa-canvas` (the Canvas brand anchor) and `REGION_FG` =
 * `--bsa-ink`. Kept as hexes here because consumers use them as JS values;
 * change them together with those vars.
 */
export const REGION_COLORS = {
  botswana: "#69907E",
  zimbabwe: "#A8B29A",
  zambia: "#C9923B",
  namibia: "#D8C7A3",
} as const;

/** Shared dark foreground used on top of the mid-tone region colours above (= `--bsa-ink`). */
export const REGION_FG = "#0A2515";
